// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jU9vQ55UXBInWKyD8rcL{gap:4px;display:flex}.SkpRwXbZVdgXDf0fKC3m{width:32px;height:32px}.zGo8I50jTYh7_31LBWfD{padding:0;display:flex}.NBKNa4_vYdEj_2CpBnn_{color:var(--content-primary-primary-inverted);text-align:center;cursor:pointer;box-sizing:border-box;border-radius:6px;min-width:28px;margin-right:4px;padding:4px;font-size:11px;font-weight:500}.NBKNa4_vYdEj_2CpBnn_.K6dZbnTeBr42S2in5H6d,.NBKNa4_vYdEj_2CpBnn_:hover{background:var(--background-primary-inverted-secondary)}.NBKNa4_vYdEj_2CpBnn_:last-of-type{margin-right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flex4": `jU9vQ55UXBInWKyD8rcL`,
	"box32": `SkpRwXbZVdgXDf0fKC3m`,
	"wrap": `zGo8I50jTYh7_31LBWfD`,
	"item": `NBKNa4_vYdEj_2CpBnn_`,
	"active": `K6dZbnTeBr42S2in5H6d`
};
export default ___CSS_LOADER_EXPORT___;
